import { RowData } from './useUpdateTableRowModalProperties';

export function transformRow(rowData: RowData): RowData {
  return {
    rowId: rowData.rowId,
    data: {
      reference: {
        companyName: rowData.data.companyName,
        costsCurrent: rowData.data.costsCurrent,
        entryDate: rowData.data.entryDate,
        financingSource: rowData.data.financingSource,
        investmentCurrency: rowData.data.investmentCurrency,
        investmentId: rowData.data.investmentId,
        investmentName: rowData.data.investmentName,
        loanId: rowData.data.loanId,
        multipleToDate: rowData.data.multipleToDate,
        salesBase: rowData.data.salesBase,
        salesOffset: rowData.data.salesOffset,
      },
      projection: {
        exitDate: rowData.data.baseExitDate,
        exitMultiple: rowData.data.baseExitMultiple,
        futureSalesProceeds: rowData.data.baseProceedsToCome,
      },
      partialSales: rowData.data.basePartialSales ?? [],
      partialSalesSum: {
        costBaseReduction: 0,
        salesDate: rowData.data.baseExitDate,
        salesProceeds: 0,
      },
    },
  };
}

export function transformRowData(rows: RowData[] = []) {
  return rows.map(transformRow);
}

export function isInvestmentAssumptionForm(type: string | undefined) {
  return (
    type != null &&
    ['addonInvestmentRow', 'unrealizedInvestmentRow'].includes(type)
  );
}
